import { render, staticRenderFns } from "./CecUnmProjectDet.vue?vue&type=template&id=620d931c&scoped=true"
import script from "./CecUnmProjectDet.vue?vue&type=script&lang=js"
export * from "./CecUnmProjectDet.vue?vue&type=script&lang=js"
import style0 from "./CecUnmProjectDet.vue?vue&type=style&index=0&id=620d931c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620d931c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('620d931c')) {
      api.createRecord('620d931c', component.options)
    } else {
      api.reload('620d931c', component.options)
    }
    module.hot.accept("./CecUnmProjectDet.vue?vue&type=template&id=620d931c&scoped=true", function () {
      api.rerender('620d931c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/cecproject/CecUnmProjectDet.vue"
export default component.exports